import axios from "axios";
export const sendEmail = (submission) => {
  console.log(submission);
  axios.post(
    `https://veeyieqt20.execute-api.us-east-1.amazonaws.com/api/sendmailbulk`,
    {
      from: "marketingamerica@momentumsolar.app",
      to: ["clantier@momentumsolar.com", "cburkhardt@momentumsolar.com"],
      subject: `Marketing America Referral`,
      body: `${JSON.stringify(submission)}`,
    }
  );
};
